import React, { forwardRef, useRef } from 'react';
import 'draft-js/dist/Draft.css';
import DraftEditor from './DraftEditor';


const DraftjsTextField = forwardRef((props, ref) => {
  const localRef = useRef(null);
  const innerRef = ref || localRef;

  return (
    <DraftEditor
      innerRef={innerRef}
      {...props}
    />
  );
});

export default DraftjsTextField;
